import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'data';
import { TemplateId } from './api';

export const selectDirtyState = (activeId: TemplateId) =>
  createSelector(
    (state: RootState) => state.templates,
    (state) => {
      return state.dirty.id === activeId ? state.dirty : null;
    },
  );
